export default __webpack_public_path__ + "static/media/alien-emoji.4157de56.png";